import printosSpinner from '@printos/angular1-spinner';
import * as gzSpinnerDirective from './spinner.directive';

export default angular.module('gazelle.components.spinner', [
  printosSpinner
])
  .directive(gzSpinnerDirective.name, gzSpinnerDirective.default)
  .name;

